document.addEventListener('click', (event) => {
  const swatch = event.target.closest('.card-swatches__swatch');
  if (!swatch) return;

  const card = swatch.closest('.card');
  if (!card) return;

  const color = swatch.dataset.color;
  const image = card.querySelector('.card__media img');
  const dataEl = card.querySelector('.card-variant-data');

  if (!image || !dataEl) return;

  const variantImages = JSON.parse(dataEl.textContent);
  const newSrc = variantImages[color];

  if (!newSrc) return;

  // Swap image
  image.src = newSrc;
  image.srcset = '';

  // Active state
  card.querySelectorAll('.card-swatches__swatch').forEach((el) => {
    el.classList.toggle('is-active', el === swatch);
  });
});
